import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import RoutesComponent from './Routes'
import { Provider } from 'react-redux'
import { store } from './store/Store'
import GlobalLoader from './Reducers/GlobalLoader'


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <GlobalLoader />
      <RoutesComponent />
    </Provider>
  </StrictMode>,
)


